// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "f74c563194e8c906","396": "8a6998631666ba3f","460": "f0966f300cb8d61f","917": "a6a122dd20aa6a3e","985": "e30e446572f85ab2",}[chunkId] + ".chunk.js"
}